import { inject, Service } from "@angular/core";

import type { MainResponseModel } from "../models";
import { NotificationCommunication, SearchFields } from "../models/notification-center-model";
import { MainService } from "./main-service";

@Service()
export class NotificationCenterApiService {
  private _mainService = inject(MainService);

  public getNotifications(
    init: boolean = false,
    loader: boolean = false,
    data?: { searchFields: SearchFields } | null,
    action?: string,
    read?: string,
    sort?: string,
    offset?: boolean
  ) {
    const defaultUrl = `commcenter/getByFiltersByUser?limit=30&offset=0&type=A&isRead=N`;
    let url = `commcenter/getByFiltersByUser?limit=30`;

    url += `&offset=${offset ? 30 : 0}`;
    if (action && action.length > 0) url += `&type=${action}`;
    if (read && read.length > 0) url += `&isRead=${read}`;
    if (sort && sort.length > 0) url += `&sortBy=${sort}`;

    return this._mainService.sendRequest<MainResponseModel<NotificationCommunication[]>>({
      method: "POST",
      url: init ? defaultUrl : url,
      data: data,
      loader: loader,
    });
  }

  public getPage({
    offset,
    limit,
    type,
    isRead,
    sortBy,
    searchFields,
  }: {
    offset: number;
    limit: number;
    type?: string;
    isRead?: string;
    sortBy?: "asc" | "desc";
    searchFields?: SearchFields;
  }) {
    const params = new URLSearchParams({ limit: `${limit}`, offset: `${offset}` });
    if (type) params.set("type", type);
    if (isRead) params.set("isRead", isRead);
    if (sortBy) params.set("sortBy", sortBy);

    return this._mainService.sendRequest<MainResponseModel<NotificationCommunication[]>>({
      method: "POST",
      url: `commcenter/getByFiltersByUser?${params}`,
      data: searchFields ? { searchFields } : null,
      loader: false,
    });
  }

  public markAsRead(id: number) {
    const url = `commcenter/read/${id}`;

    return this._mainService.sendRequest<MainResponseModel<NotificationCommunication[]>>({
      method: "GET",
      url,
    });
  }
}
